/**
 * LastAnalysisStamp — VP-256. Znacznik „z kiedy jest ta analiza", w kolorze
 * odpowiadającym jej świeżości (zielony / pomarańczowy / czerwony). Plakietka
 * w nagłówku panelu rekomendacji — pokazuje status bez ponownego (płatnego)
 * przeliczania analizy.
 */

import { useTranslation } from "react-i18next";
import { type AnalysisFreshness } from "@/hooks/useLatestAnalysis";

const FRESHNESS_CLASSES: Record<AnalysisFreshness, string> = {
  fresh: "bg-green-600/15 text-green-400 border-green-500/25",
  aging: "bg-orange-600/15 text-orange-400 border-orange-500/25",
  stale: "bg-red-600/15 text-red-400 border-red-500/25",
};

type Props = {
  createdAt: string;
  freshness: AnalysisFreshness;
};

/** Data + godzina w lokalnej strefie użytkownika (np. „30.07.2026, 14:20"). */
function formatStamp(createdAt: string): string {
  return new Date(createdAt).toLocaleString(undefined, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export default function LastAnalysisStamp({ createdAt, freshness }: Props) {
  const { t } = useTranslation("recommendationsPanel");

  return (
    <span
      className={`text-[10px] px-1.5 py-0.5 rounded border font-medium ${FRESHNESS_CLASSES[freshness]}`}
      title={t("panel.cachedHint")}
    >
      {t("panel.analysisFrom", { date: formatStamp(createdAt) })}
    </span>
  );
}
